import { Box, CircularProgress, Typography, styled } from "@mui/material";
import { FormSelectInput } from "@/components/custom/custom-form-select-input";
import { CustomButton } from "@/components/custom/custom-button";
import { FormTextInput } from "@/components/custom/custom-form-text-input";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),

  [theme.breakpoints.up("lg")]: {
    flexDirection: "row",
  },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,

  [theme.breakpoints.up("lg")]: {
    width: 256,
  },
}));

const Content = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Grid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),

  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "1fr 1fr",
  },
}));

export const BaseConfig = ({ formik, isDisabled }) => {
  return (
    <Wrapper>
      <Row>
        <Side>
          <Typography fontWeight={600} fontSize="1.05rem">
            Product Configuration
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Configure your product here
          </Typography>
        </Side>

        <Content>
          <Grid>
            <FormSelectInput
              formik={formik}
              name="visibility"
              label="Visibility"
              options={[
                { value: true, label: "True" },
                { value: false, label: "False" },
              ]}
              isDisabled={isDisabled}
            />

            <FormTextInput
              formik={formik}
              name="minAmount"
              label="Minimum Amount"
              isDisabled={isDisabled}
            />
            <FormTextInput
              formik={formik}
              name="maxAmount"
              label="Maximum Amount"
              isDisabled={isDisabled}
            />
            <FormTextInput
              formik={formik}
              name="dailyLimit"
              label="Daily Limit"
              isDisabled={isDisabled}
            />
          </Grid>

          <Box display="flex" justifyContent="flex-end">
            <CustomButton
              type="submit"
              variantType="outline"
              size="small"
              disabled={!formik.isValid || !formik.dirty}
              sx={{
                minWidth: 140,
                px: 2,
              }}
            >
              {isDisabled ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <CircularProgress size={16} thickness={5} />
                  Saving...
                </Box>
              ) : (
                "Save Changes"
              )}
            </CustomButton>
          </Box>
        </Content>
      </Row>
    </Wrapper>
  );
};
